import React from 'react';
import { Crown } from 'lucide-react';
import { cn } from '@/lib/utils';

export function PremiumBadge({ size = 'sm', className }) {
  return (
    <Crown
      className={cn(
        'text-emerald-600',
        size === 'sm' && 'w-3 h-3',
        size === 'md' && 'w-4 h-4',
        className
      )}
    />
  );
}
